import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useStatesDropdowns } from "../../actions/authActions";
import { SwalAlert } from "../../components";
export default () => {
  const dispatch = useDispatch();
  const jobId = useSelector((state) => state.app.jobId.jobId);
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const fetchjoblisting = async ({ queryKey }) => {
    const [, jobId] = queryKey;
    const { data } = await axios.get(`${baseURL}/api/v2/job/${jobId}`);
    return data?.data;
  };

  const { data: jobListing, isLoading: isLoadingprefilled } = useQuery({
    queryKey: ["jobListing", jobId],
    queryFn: fetchjoblisting,
    enabled: jobId !== null && jobId !== undefined,
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: jobListing?.title || "",
      job_type_id: jobListing?.job_type_id || "",
      countries: jobListing?.country_id || "",
      state_id: jobListing?.state_id ? String(jobListing.state_id) : "",
      city_id: jobListing?.city_id || "",
      job_shift_id: jobListing?.job_shift_id
        ? String(jobListing.job_shift_id)
        : "",
      gender: jobListing?.gender_id ? String(jobListing.gender_id) : "",
      degree_level_id: jobListing?.degree_level_id
        ? String(jobListing.degree_level_id)
        : "",
      job_experience_id: jobListing?.job_experience_id
        ? String(jobListing.job_experience_id)
        : "",
      salary_period_id: jobListing?.salary_period_id
        ? String(jobListing.salary_period_id)
        : "",
      expiry_date: jobListing?.expiry_date || "",
      postal_code: jobListing?.postal_code || "",
      salary_from: jobListing?.salary_from || "",
      salary_to: jobListing?.salary_to || "",
      num_of_positions: jobListing?.num_of_positions || "",
      description: jobListing?.description || "",
      benefits: jobListing?.benefits || "",
    },
  });

  useEffect(() => {
    if (
      !isLoadingprefilled &&
      jobListing &&
      Object.keys(jobListing).length > 0
    ) {
      setValue("title", jobListing.title);
      setValue("postal_code", jobListing.postal_code);
      setValue("expiry_date", jobListing.expiry_date);
      setValue("salary_from", jobListing.salary_from);
      setValue("num_of_positions", jobListing.num_of_positions);
      setValue("salary_to", jobListing.salary_to);
      setValue(
        "countries",
        jobListing.country_id ? String(jobListing.country_id) : ""
      );
      setValue(
        "job_type_id",
        jobListing?.job_type_id ? String(jobListing?.job_type_id) : ""
      );
      setValue(
        "state_id",
        jobListing.state_id ? String(jobListing.state_id) : ""
      );
      setValue("city_id", jobListing.city_id ? String(jobListing.city_id) : "");
      setValue(
        "job_shift_id",
        jobListing.job_shift_id ? String(jobListing.job_shift_id) : ""
      );
      setValue(
        "gender",
        jobListing?.gender_id ? String(jobListing.gender_id) : ""
      );
      setValue(
        "degree_level_id",
        jobListing?.degree_level_id ? String(jobListing.degree_level_id) : ""
      );
      setValue(
        "job_experience_id",
        jobListing?.job_experience_id
          ? String(jobListing.job_experience_id)
          : ""
      );
      setValue(
        "salary_period_id",
        jobListing?.salary_period_id ? String(jobListing.salary_period_id) : ""
      );
      setValue(
        "description",
        jobListing?.description ? String(jobListing.description) : ""
      );
      setValue(
        "benefits",
        jobListing?.benefits ? String(jobListing.benefits) : ""
      );
    }

    setSelectedOption({
      is_freelance: jobListing?.is_freelance,
      hide_salary: jobListing?.hide_salary,
      is_active: jobListing?.is_active,
      is_featured: jobListing?.is_featured,
    });
  }, [jobListing, isLoadingprefilled, setValue]);

  const [selectedOption, setSelectedOption] = useState({
    is_freelance: jobListing?.is_freelance,
    hide_salary: jobListing?.hide_salary,
    is_active: jobListing?.is_active,
    is_featured: jobListing?.is_featured,
  });

  const userData = useSelector((state) => state.app.userData.userData);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const mutation = useMutation({
    mutationFn: async (updateJobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/job/${jobId}`,
        updateJobData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: "UPDATE_CREATE_JOB_DATA",
        payload: { createJobData: data },
      });
      SwalAlert(data?.status, data?.message, "success");
      setLoadingToapi(false);
      navigate("/empjob-listing");
    },
    onError: (error) => {
      const message = error.response?.data?.errors;
      setLoadingToapi(false);
      SwalAlert("Oops...", message, "error");
    },
  });
  const fetchJobDropdowns = async () => {
    const { data } = await axios.get(`${baseURL}/api/job-dropdowns`);
    return data;
  };

  const { data: jobDropdowns, isLoading: prefiledjobDropdowns } = useQuery({
    queryKey: ["jobDropdowns"],
    queryFn: fetchJobDropdowns,
  });
  const fetchdropdowns = async () => {
    const { data } = await axios.get(`${baseURL}/api/dropdowns`);
    return data;
  };

  const { data: dropdowns, isLoading } = useQuery({
    queryKey: ["dropdowns"],
    queryFn: fetchdropdowns,
  });

  const selectedCountry = watch("countries");
  const selectedState = watch("state_id");
  const { data: states, isLoading: isLoadingStates } =
    useStatesDropdowns(selectedCountry);

  const fetchcities = async () => {
    const { data } = await axios.get(`${baseURL}/api/cities/${selectedState}`);
    return data;
  };

  const { data: cities, isLoading: prefiledCitiesDropdowns } = useQuery({
    queryKey: ["cities"],
    queryFn: fetchcities,
    enabled: !!selectedState,
  });

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const createJobData = {
      company_id: userData?.employer?.id || jobListing?.company_id,
      title: data.title || jobListing?.title,
      job_type_id: data.job_type_id || jobListing?.job_type_id,
      description: data?.description || jobListing?.description,
      benefits: data?.benefits || jobListing?.benefits,
      salary_from: data.salary_from || jobListing?.salary_from,
      salary_to: data.salary_to || jobListing?.salary_to,
      country_id: data.countries || jobListing?.country_id,
      state_id: data.state_id || jobListing?.state_id,
      city_id: data.city_id || jobListing?.city_id,
      salary_period_id: data.salary_period_id || jobListing?.salary_period_id,
      job_shift_id: data.job_shift_id || jobListing?.job_shift_id,
      gender_id: data.gender_id || jobListing?.gender_id,
      expiry_date: data.expiry_date || jobListing?.expiry_date,
      num_of_positions: data.num_of_positions || jobListing?.num_of_positions,
      degree_level_id: data.degree_level_id || jobListing?.degree_level_id,
      job_experience_id:
        data.job_experience_id || jobListing?.job_experience_id,
      postal_code: data.postal_code || jobListing?.postal_code,
      is_featured: selectedOption?.is_featured ?? jobListing?.is_featured,
      is_active: selectedOption?.is_active ?? jobListing?.is_active,
      hide_salary: selectedOption?.hide_salary ?? jobListing?.hide_salary,
      is_freelance: selectedOption?.is_freelance ?? jobListing?.is_freelance,
      _method: "PUT",
    };
    mutation.mutate(createJobData);
  };
  return {
    handleSubmit,
    control,
    errors,
    isLoading,
    jobListing,
    isLoadingprefilled,
    setValue,
    register,
    setSelectedOption,
    selectedOption,
    onSubmit,
    dropdowns,
    jobDropdowns,
    prefiledjobDropdowns,
    states,
    isLoadingStates,
    cities,
    prefiledCitiesDropdowns,
    loadingToapi,
  };
};
